import(/* webpackMode: "eager" */ "/home/ubuntu/app/hellojob-pro/src/app/gioi-thieu-ban-be/page.tsx");
